import { render, staticRenderFns } from "./roundedModalButton.vue?vue&type=template&id=6988e96e"
import script from "./roundedModalButton.vue?vue&type=script&lang=js"
export * from "./roundedModalButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports